export const headers = [
    { label: "Personal", icon: "", className: "detale-p-propinas__cell-personal" },
    { label: "Propina recolectada", icon: "circleMinus", className: "detale-p-propinas__cell-pr" },
    { label: "Aportación a fondo", icon: "circleEqual", className: "detale-p-propinas__cell-af" },
    { label: "Subtotal propina por ventas", icon: "circleMinus", className: "detale-p-propinas__cell-spv" },
    {
        label: "Comisión bancaria sobre propina por venta",
        icon: "circleEqual",
        className: "detale-p-propinas__cell-cbpv",
    },
    { label: "Neto propina por ventas", icon: "circleMore", className: "detale-p-propinas__cell-npv" },
    { label: "Fondo de propina", icon: "circleMinus", className: "detale-p-propinas__cell-fp" },
    { label: "Comisión bancaria sobre fondo", icon: "circleEqual", className: "detale-p-propinas__cell-cbsf" },
    { label: "Pago correspondiente", icon: "", className: "detale-p-propinas__cell-pc" },
]
